import { IController, IScope } from 'angular';
import { inject, injectable } from '../../../../shared/utils/inject/inject';
import { makeRGBA } from '../../utils/colorUtils';

@injectable
export class DynamicStyleController implements IController {
  @inject private wixSdk: any;
  @inject private $scope: IScope;
  public params: { fonts: {}; colors: {} };
  public siteColors: any;

  public rgba(color, opacity) {
    if (!color) {
      return;
    }
    return makeRGBA(color, opacity);
  }

  $onInit(): void {
    const { wixSdk } = this;

    const onStylesParamsUpdate = () => {
      this.$scope.$apply(() => {
        this.updateWidgetData();
      });
    };

    wixSdk.addEventListener(
      wixSdk.Events.STYLE_PARAMS_CHANGE,
      onStylesParamsUpdate,
    );

    this.$scope.$on('$destroy', () => {
      wixSdk.removeEventListener(
        wixSdk.Events.STYLE_PARAMS_CHANGE,
        onStylesParamsUpdate,
      );
    });
  }

  private updateWidgetData() {
    const { wixSdk } = this;

    wixSdk.Styles.getStyleParams(params => {
      const colors = this.normalize(params.colors);
      const fonts = this.normalize(params.fonts);
      this.params = { colors, fonts };
    });

    wixSdk.Styles.getSiteColors(siteColors => {
      this.siteColors = siteColors.reduce((colors, { reference, value }) => {
        colors[reference] = value;
        return colors;
      }, {});
    });
  }

  private normalize(obj) {
    return Object.keys(obj).reduce((normalized, key) => {
      normalized[key] = obj[key].value || obj[key];
      return normalized;
    }, {});
  }
}
